import React, { useEffect, useContext } from "react";
import { BookContext } from "../../context/books";
import Present from '../PresentList/Present';
import Loading from "../Loader/Loader";
import "./PresentList.css";


const PresentList = () => {
    const {presents, fetchPresent, loading, resultTitle } = useContext(BookContext);

    useEffect(() => {
        fetchPresent();
      }, [fetchPresent]);
    if(loading) return <Loading />;

    return (
        <section className='presentlist'>
            <div className="container">
                <h2 className="result">{resultTitle}</h2>
            </div>
            <div className="presentlist-content grid">
                {presents.slice(0, 300).map((item, index) => {
                    return (
                        <Present key = {index} {... item} />
                    )
                })}
            </div>
        </section>
    )
}

export default PresentList;